import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import foodWebsite from "../assets/img/Food Website.png";
import keepNotes from "../assets/img/keepNotes.png";
import AmazonClone from "../assets/img/amazonClone.png";
import sorting from "../assets/img/SoringVisulizer.png";
import drumKit from "../assets/img/drumKit.png"
import simons from "../assets/img/simonsgame.png"

import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Amazon Clone",
      description: "Fully functional amazon clone with user authentication, Cart functionality and payment gateway",
      imgUrl: AmazonClone,
    },
    {
      title: "Keeper",
      description: "Functioning Note taking app made with React.js",
      imgUrl: keepNotes,
    },
    {
      title: "Sorting Visualizer",
      description: "Javascript, HTML/CSS",
      imgUrl: sorting,
    },
    {
      title: "Food Website",
      description: "Modern landing page for a restaurant",
      imgUrl: foodWebsite,
    },
    {
      title: "Simons Game",
      description: "Famous Simons Game implemented with javascript",
      imgUrl: simons,
    },
    {
      title: "Drum Kit",
      description: "Just for fun ",
      imgUrl: drumKit,
    },
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>I specialize in web development, with a focus on the MERN (MongoDB, Express.js, React, Node.js) stack. With expertise in front-end development and creating dynamic user interfaces, I use React, Redux, and Firebase to build scalable web applications. Let's bring your project to life together!</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <p>More Upcoming.....</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>More Upcoming.....</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}